const action = "BLUEPRINT_CREATE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const FAILURE = action+'_FAILURE';
export const CLEAR = action+'_CLEAR';

export const createBlueprintRequest = (blueprintData) => {
  return {
    type: REQUEST,
    payload: blueprintData
  };
};

export const createBlueprintSuccess = (response) => {
  return {
    type: RESPONSE,
    payload: response
  };
};

export const createBlueprintFailure = (error) => {
  return {
    type: FAILURE,
    payload: error
  };
};

export const clearState = () => ({
  type: CLEAR
}); 